import React from 'react';
import ReactDOM from 'react-dom';
import { MenuOutlined } from '@ant-design/icons';
import { MapModuleButton } from '../../../mapping/mapmodule/MapModuleButton';

/**
 * @class Oskari.userinterface.plugin.ToggleNavigationPlugin
 * Displays a full screen toggle button on the map.
 */
Oskari.clazz.define('Oskari.userinterface.plugin.ToggleNavigationPlugin',
/**
 * @static @method create called automatically on construction
 *
 */
function () {
  var me = this;
  me._clazz = 'Oskari.userinterface.plugin.ToggleNavigationPlugin';
  me._defaultLocation = 'top left';
  me._index = 2;
  me._name = 'ToggleNavigationPlugin';
  me._element = null;
  var isMobile = Oskari.util.isMobile();
  me._sandbox = null;
  this._isVisible = isMobile;
  this._active = this._isVisible && Oskari.dom.isNavigationVisible();
  me._templates = {
    plugin: jQuery('<div class="mapplugin togglenavigation"></div>')
  };
}, {
  /**
   * @method _createControlElement
   *
   * @return {jQuery}
   * Plugin jQuery element
   */
  _createControlElement: function _createControlElement() {
    return this._templates.plugin.clone();
  },
  /**
   * @method _startPluginImpl
   */
  _startPluginImpl: function _startPluginImpl() {
    this.setElement(this._createControlElement());
    this.addToPluginContainer(this.getElement());
    this.refresh();
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public createPluginUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    this.refresh();
  },
  /**
   * @public @method refresh
   */
  refresh: function refresh() {
    var _this = this;
    var el = this.getElement();
    var nav = Oskari.dom.getNavigationEl();
    if (!el || !nav) {
      return;
    }
    var isToggled = !!Oskari.dom.isNavigationVisible();
    this._active = isToggled;

    // Fixes button staying active or hovered after click
    ReactDOM.unmountComponentAtNode(el[0]);
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_navigationtoggle",
      visible: this.isVisible(),
      icon: /*#__PURE__*/React.createElement(MenuOutlined, null),
      iconActive: isToggled,
      iconSize: "20px",
      onClick: function onClick(e) {
        Oskari.dom.showNavigation(!isToggled);
        _this.redrawUI();
      },
      position: this.getLocation(),
      isNav: true
    }), el[0]);
  },
  teardownUI: function teardownUI() {
    this.removeFromPluginContainer(this.getElement());
  },
  /**
   * @method _stopPluginImpl
   *
   * @param {Oskari.mapframework.sandbox.Sandbox} sandbox
   *          reference to application sandbox
   */
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
  },
  isVisible: function isVisible() {
    return this._isVisible;
  },
  /**
   * @method _createEventHandlers
   * Create eventhandlers.
   *
   *
   * @return {Object.<string, Function>} EventHandlers
   */
  _createEventHandlers: function _createEventHandlers() {
    return {
      MapSizeChangedEvent: function MapSizeChangedEvent(evt) {
        // Hide navigation when moving from desktop to mobile
        if (Oskari.dom.isNavigationVisible() && !this._isVisible && Oskari.util.isMobile()) {
          this._isVisible = true;
          Oskari.dom.showNavigation(false);
          this.refresh();
        }
        if (this._active !== Oskari.dom.isNavigationVisible()) {
          this.refresh();
        }
      }
    };
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});